import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

interface DialogProp {
  cancelText: string;
  title: string;
  body: string;
}

// TODO: What is this component for? @Bao

@Component
export default class RatingField extends Vue {
  @Prop({ default: true }) view: boolean;
  @Prop({ default: 0 }) value: number;
  @Prop({ default: true }) canInput: boolean;
  @Prop({
    default: (): DialogProp => ({
      cancelText: 'OK',
      title: 'Cannot input SAT',
      body:
        'SAT (Project satisfaction) can only be entered after the project has ended or the evaluation process has been initiated.'
    })
  })
  dialogProps: DialogProp; // TODO: Redundant? @Bao

  private rate: number = 0 as number;
  private errorRate = '';
  private preEmitError = true;

  get isViewMode(): boolean {
    return this.view;
  }

  get rateValue(): number {
    return +this.rate;
  }

  get haveError(): boolean {
    return this.rate < 0 || +this.rate > 5;
  }

  emitInput(value: boolean): void {
    if (value) {
      this.$emit('error', value);
      this.errorRate = 'Invalid rate number!';
      this.preEmitError = true;
    } else {
      if (this.preEmitError) {
        this.$emit('error', value);
        this.errorRate = '';
        this.preEmitError = !this.preEmitError;
      }
      this.$emit('input', this.rateValue);
    }
  }

  setRateValue(data: number): void {
    this.rate = data;
  }

  @Watch('rate')
  onRateChange(): void {
    this.emitInput(this.haveError);
  }

  @Watch('isViewMode')
  onModeChange(): void {
    this.rate = this.value;
  }

  created(): void {
    this.rate = this.value;
  }
}
